'use strict';

require('../icon/style.js');

require('../animate/style.js');

require('./main.scss');